import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/lang";
import { useSeo } from "../lib/seo";
import { api, fmtUSD } from "../lib/api";

const ROMAN = ["I","II","III","IV","V"];

export default function ServicesIndex() {
  const { t, lang } = useLang();
  const [services, setServices] = useState([]);

  useSeo({
    title: lang === "es"
      ? "Servicios de marca — Brand and Behavior · Precios fijos"
      : "Brand Services — Brand and Behavior · Fixed pricing",
    description: lang === "es"
      ? "Cinco servicios productizados: Brand Scan, Brand Development, Brand Strategy, Brand Partner y Brand Office. Alcance fijo, precio fijo."
      : "Five productized brand services: Brand Scan, Brand Development, Brand Strategy, Brand Partner and Brand Office. Fixed scope, fixed price.",
    path: lang === "es" ? "/es/services" : "/services",
  });

  useEffect(() => { api.get(`/services?lang=${lang}`).then((r) => setServices(r.data)); }, [lang]);

  return (
    <main className="app-main" data-testid="services-index">
      <section className="page-hero">
        <div className="kicker">{t("Services", "Servicios")}</div>
        <h1>{t("Five ways to work with us.", "Cinco formas de trabajar con nosotros.")}</h1>
        <p>{t("Fixed scope, fixed price, brand solutions by default.", "Alcance fijo, precio fijo, brand solutions por defecto.")}</p>
      </section>
      <section className="svc-grid">
        {services.map((s, idx) => (
          <Link to={`/services/${s.slug}`} className="svc-card" key={s.slug} data-testid={`svc-card-${s.slug}`}>
            <div className="svc-roman">{ROMAN[idx] || "·"}</div>
            <div>
              <div className="svc-name">{s.name}</div>
              <div className="svc-tagline">{s.tagline}</div>
              <div className="svc-meta">
                <span>{s.format}</span>
                <span>{s.duration}</span>
              </div>
            </div>
            <div>
              <div className="svc-price">
                {s.price ? fmtUSD(s.price) : <em className="it">{t("On request", "Bajo consulta")}</em>}
                {s.billing === "monthly" && <span className="per">/{t("mo", "mes")}</span>}
              </div>
              <div className="svc-cta">{t("Open", "Abrir")} <span className="arrow">→</span></div>
            </div>
          </Link>
        ))}
      </section>
    </main>
  );
}
